import { batch } from 'react-redux';

import FullBuyAnalytics from '~/src/features/full-buy/analytics';
import { addProduct, setSelectedPrice } from '~/src/features/full-buy/store/actions';
import { TProduct } from '~/src/features/full-buy/store/transformShopItem';
import { TAppThunkDispatch } from '~/src/store';

/**
 * Добавляет продукт и устанавливает выбранную цену
 */
export const addEquipment = (currentEquipment: TProduct | undefined, cost: number, analytics: FullBuyAnalytics) => {
    return async(dispatch: TAppThunkDispatch): Promise<void> => {
        if (!currentEquipment) {
            return;
        }

        const selectedPrice = currentEquipment.prices.find(el => el.cost === cost);

        if (!selectedPrice) {
            return;
        }

        batch(() => {
            dispatch(setSelectedPrice(currentEquipment.id, selectedPrice.duration));
            dispatch(addProduct(currentEquipment.id));
        });

        analytics.equipment.addProduct(currentEquipment.title);
    };
};
